import * as formik from 'formik';
import * as yup from 'yup';
import { useState, useEffect } from 'react';
import FileDropArea from '../FileDropArea'
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { uploadAssetTitle, getAssetTitleForm } from '../../utils/api';
import Loader from '../Loader';
import { bytesToBase64 } from '../../utils/helpers';
import Success from '../Success';
import Error from '../Error';

const CreateAssetTitleModal = ({ show, onHide, asset }) => {

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const [filename, setFilename] = useState(false);
    const [fileType, setFileType] = useState(false);
    const [bytes, setBytes] = useState(false);

    const fetchData = async () => {
        setLoading(true);

        const data = await getAssetTitleForm();
        if (data) {
            setData(data);
        }
        else {
            setError('Failed to fetch data');
        }
        setLoading(false);
    };


    const reset = () => {
        setData({});
        setError(null);
        setLoading(false);
    };

    useEffect(() => {
        const onLoad = () => {
            if (show)
                fetchData();
            else
                reset();
        }
        onLoad();
    }, [show]);

    const uploadTitle = async (filename, fileType, bytes) => {
        setFilename(filename);
        setFileType(fileType);
        setBytes(bytes);
    }

    const closeModal = (shouldRefresh) => {
        setLoading(false);
        setIsSaving(false);
        setError(null);
        setIsSaved(false);
        onHide(shouldRefresh);
    }

    const { Formik } = formik;
    const schema = yup.object().shape({
        state: yup.string().required('This field is required'),
        titleNumber: yup.string().required('This field is required'),
    });

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Asset Title</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading || isSaving ? <Loader /> : error ? <Error /> : isSaved ? (
                        <div style={{ height: 230, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Success />
                        </div>
                    ) : (
                        <Formik
                            validationSchema={schema}
                            onSubmit={async (form) => {

                                if (!filename) return;
                                if (!bytes) return;
                                if (!fileType) return;

                                setLoading(true);
                                const data = asset && await uploadAssetTitle(asset.Id, form.state, form.titleNumber, filename, bytes, fileType);
                                const success = data?.Success ?? false;
                                if (success) {
                                    setIsSaved(true);
                                }
                                else {
                                    setError("an error occured")
                                }

                                setIsSaving(false);
                                setLoading(false);

                                if (success)
                                    setTimeout(() => closeModal(true), 2000);
                            }}
                            initialValues={{
                                state: '',
                                titleNumber: '',
                            }}
                        >
                            {({ handleSubmit, handleChange, values, touched, errors }) => (


                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={6} sm={6} md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Control
                                                    id='state'
                                                    as="select"
                                                    value={values.state}
                                                    isInvalid={errors.state} isValid={values.state && !errors.state} aria-label="State"
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select a state</option>
                                                    {data?.States?.map((o, index) => (
                                                        <option key={o.Code} value={o.Code}>{o.Name}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Control.Feedback type='invalid'>{errors.state}</Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Label className="mb-3" style={{ fontSize: 10 }} htmlFor="state"><span style={{ color: 'red' }}>*</span>Titling State</Form.Label>
                                        </Col>

                                        <Col xs={6} sm={6} md={6} lg={6}>
                                            <InputGroup>
                                                <Form.Control id="titleNumber" value={values.titleNumber} onChange={handleChange} isInvalid={errors.titleNumber} isValid={values.titleNumber && !errors.titleNumber} aria-label="Title Number" />
                                                <Form.Control.Feedback type='invalid'>{errors.titleNumber}</Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Label className="mb-3" style={{ fontSize: 10 }} htmlFor="firstName"><span style={{ color: 'red' }}>*</span>Title Number</Form.Label>
                                        </Col>
                                    </Row>


                                    <div style={{ padding: 10, textAlign: 'center' }}>
                                        {bytes && (
                                            <img src={`data:image/jpg;base64,${bytesToBase64(bytes)}`} alt="Title Image" style={{ maxWidth: 180, width: 'auto', height: 84, }} />
                                        ) || (
                                                <FileDropArea isImage={true} style={{ minHeight: 250 }} onFileSelected={uploadTitle} footerText='Recommended: .png, .jpg, .jpeg, .webp, .heic, .jfif' />
                                            )}
                                    </div>

                                    <br />

                                    <Button style={{ width: '100%' }} type="submit">Save</Button>
                                </Form>

                            )}
                        </Formik>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );
};

export default CreateAssetTitleModal;